import { GET_DATA } from "../services";
import { GET_DATA_INFO } from "./constants";

const getData_ = (res) => ({
    type: GET_DATA_INFO,
    data: res.data,
});

export const getData_Action = () => {

  return dispatch=> {
    GET_DATA().then((res) => {
      
      dispatch(getData_(res));
    });
  };
};
